import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'

const GreenSection = ({ t }) => (
  <section className="pomelo-cares-green">
    <span className={clsx(Typo.body2, 'text-body')}>
      {hasLocizeTranslation(
        t,
        'POMELO_CARE_GREEN_BODY',
        'Charity partners that benefit from your donation:',
      )}
    </span>
    <span className={clsx(Typo.subtitle2, 'text-foundations')}>
      {hasLocizeTranslation(
        t,
        'POMELO_CARE_GREEN_FOUNDATIONS',
        `Fallback Foundation
Another Foundation
Last Foundation`,
      )}
    </span>
  </section>
)

GreenSection.propTypes = {
  t: PropTypes.func.isRequired,
}

export default GreenSection
